var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image',{attrs:{"href":"https://allys3163848-dev.s3.ap-northeast-1.amazonaws.com/Master/planeView/common/water-mark.png","width":"1000","height":"1000"}})}
var staticRenderFns = []

export { render, staticRenderFns }